import { EmailOutlined, PhoneIphoneOutlined } from 'ui/icons';

import { Root } from './styles';

export const OtpIcon = ({ variant }: { variant: 'email' | 'phone' }) => (
  <Root>{variant === 'email' ? <EmailOutlined color="primary" /> : <PhoneIphoneOutlined color="primary" />}</Root>
);
